/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceReportedCalibrationData
 */
export interface DeviceReportedCalibrationData {
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceReportedCalibrationData
     */
    creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceReportedCalibrationData
     */
    lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    calibrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    $type?: DeviceReportedCalibrationDataTypeEnum;
}


/**
 * @export
 */
export const DeviceReportedCalibrationDataTypeEnum = {
    PtwPtw100AppZeroCoreSharedDeviceComponentCalibrationDeviceReportedCalibrationDataPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.DeviceComponent.Calibration.DeviceReportedCalibrationData, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type DeviceReportedCalibrationDataTypeEnum = typeof DeviceReportedCalibrationDataTypeEnum[keyof typeof DeviceReportedCalibrationDataTypeEnum];



/**
 * Check if a given object implements the DeviceReportedCalibrationData interface.
 */
export function instanceOfDeviceReportedCalibrationData(value?: unknown): value is DeviceReportedCalibrationData {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DeviceReportedCalibrationDataTypeEnum)[0];
}

export function DeviceReportedCalibrationDataFromJSON(json: any): DeviceReportedCalibrationData {
    return DeviceReportedCalibrationDataFromJSONTyped(json, false);
}

export function DeviceReportedCalibrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceReportedCalibrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'deviceId': json['deviceId'] == null ? undefined : json['deviceId'],
        'masterDeviceId': json['masterDeviceId'] == null ? undefined : json['masterDeviceId'],
        'calibrationCertificateNumber': json['calibrationCertificateNumber'] == null ? undefined : json['calibrationCertificateNumber'],
        'calibrationDate': json['calibrationDate'] == null ? undefined : json['calibrationDate'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DeviceReportedCalibrationDataToJSON(value?: DeviceReportedCalibrationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'creationTime': value['creationTime'],
        'creatorUserId': value['creatorUserId'],
        'lastModificationTime': value['lastModificationTime'],
        'lastModifierUserId': value['lastModifierUserId'],
        'deviceId': value['deviceId'],
        'masterDeviceId': value['masterDeviceId'],
        'calibrationCertificateNumber': value['calibrationCertificateNumber'],
        'calibrationDate': value['calibrationDate'],
        '$type': value['$type'],
    });
}

